<section class="ch3">
    <section class="header-zone">
        <ng-content select="[header-zone]"></ng-content>
    </section>
    <section class="visu-zone">
        <ng-content select="[visu-zone]"></ng-content>
    </section>
    <section class="footer-zone">
        <ng-content select="[footer-zone]"></ng-content>
    </section>
</section>